'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-cartesian-chart/index.js');

var _index2 = _interopRequireDefault(_index);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ref = _sdk2.default.utils;
var configUtils = ref.configUtils;
var constants = ref.constants;
var colorUtils = _sdk2.default.color.colorUtils;

var ComboChart = function (AbstractCartesianChart) {
  function ComboChart() {
    AbstractCartesianChart.apply(this, arguments);
  }

  if (AbstractCartesianChart) ComboChart.__proto__ = AbstractCartesianChart;
  ComboChart.prototype = (0, _create2.default)(AbstractCartesianChart && AbstractCartesianChart.prototype);
  ComboChart.prototype.constructor = ComboChart;
  return ComboChart;
}(_index2.default);

exports.default = ComboChart;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;